import React, { useContext } from "react";
import styled from "styled-components";
import getImageURL from "../../../../../controllers/getImageURL";
import CustomButton from "../../../../helperComponents/CustomButton";
import Context from "../../../../../Context";
import AddOrEditForm from "../AddOrEditForm";
import { useTranslation } from "react-i18next";
import limitStringLength from "../../../../../controllers/limitStringLength";
import { AiOutlinePlus } from "react-icons/ai";

const Card = styled.div`
  border-radius: 15px;
  padding: 10px;
  width: 350px;
  overflow: hidden;
  position: relative;
  transition: all 0.25s ease-in-out;
  display: flex;
  flex-direction: column;
  gap: 20px;

  background: var(--surface);
  border: 1px solid var(--border);
  color: var(--element);

  @media (max-width: 900px) {
    width: 100%;
  }
`;

const NewCard = styled.div`
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 15px;
  padding: 10px;
  width: 350px;
  overflow: hidden;
  position: relative;
  transition: all 0.25s ease-in-out;
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 900px) {
    width: 100%;
  }
`;

const Image = styled.img`
  width: 100%;
  height: 200px;
  border-radius: 10px;
  object-fit: cover;
`;

const ProfileContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

const Name = styled.div`
  font-weight: 900;
  font-size: 19px;
  text-transform: capitalize;
  font-family: var(--headingFont);
`;

const Status = styled.div`
  /* padding: 5px 10px; */
  border-radius: 5px;
  text-transform: capitalize;
  font-weight: 500;
`;

const ProfileText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;

const ActionButtons = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 10px;
  flex-direction: column;
`;

const Data = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const FiledValue = styled.div`
  opacity: 0.7;
  font-size: 18px;
  line-height: 21px;
`;

export default function ManageAnnouncementCard({
  item,
  index,
  items,
  setItems,
  forAddingNewItem,
}) {
  const { t } = useTranslation();
  const { setForm } = useContext(Context);

  let fields = [
    {
      type: "IMAGE",
      name: "image",
      label: t("adminPageAnnouncementFormImage"),
    },
    {
      type: "STRING",
      name: "title",
      label: t("adminPageAnnouncementFormTitle"),
    },

    {
      type: "REALLY_LONG_STRING",
      name: "description",
      label: t("adminPageAnnouncementFormLongDescription"),
    },
  ];

  if (forAddingNewItem)
    return (
      <CustomButton
        icon={<AiOutlinePlus />}
        style={{ background: "var(--surface)" }}
        onClick={addItem}
      >
        {t("clickHereToAddNew")}
      </CustomButton>
    );

  return (
    <Card>
      <ProfileContainer>
        <Image src={getImageURL(item.image, false)} alt="Image" />
        <ProfileText>
          <Name>{item.title} </Name>
          <FiledValue>{limitStringLength(item.description, 100)}</FiledValue>
        </ProfileText>
      </ProfileContainer>

      <ActionButtons>
        <CustomButton
          style={{ background: "var(--surface)" }}
          onClick={editItem}
        >
          {t("adminPageAnnouncementsEditItem")}
        </CustomButton>
      </ActionButtons>
    </Card>
  );

  function addItem() {
    setForm({
      title: "Add Item",
      component: (
        <AddOrEditForm
          arrayItems={items}
          setArrayItems={setItems}
          fields={fields}
          path="/admin/announcement"
        />
      ),
    });
  }

  function editItem() {
    setForm({
      title: "Edit Item",
      component: (
        <AddOrEditForm
          arrayItems={items}
          setArrayItems={setItems}
          index={index}
          fields={fields}
          values={item}
          path="/admin/announcement"
        />
      ),
    });
  }
}
